import { render, staticRenderFns } from "./AddArticlesSections.vue?vue&type=template&id=45d8cac2&scoped=true&"
import script from "./AddArticlesSections.vue?vue&type=script&lang=js&"
export * from "./AddArticlesSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d8cac2",
  null
  
)

export default component.exports